import { translate } from "app/filters/i18nFilter";
import { MODAL_TEXTS } from "app/pages/activation/components/Topics/texts";
import { MAX_TOPICS, MAX_TOPICS_FOR_ONE_ADD } from "app/pages/activation/components/Topics/Modal/constants";

export const validateTopicsCreationLength = (createdTopics: number, selectedTopics: number) => {
    const isMaxSelected = selectedTopics + createdTopics >= MAX_TOPICS;
    const isMaxForOneAddSelected = selectedTopics >= MAX_TOPICS_FOR_ONE_ADD;
    let message = "";

    if (isMaxSelected) {message = translate(MODAL_TEXTS.maxCreatedTooltip, { max: MAX_TOPICS });}

    if (isMaxForOneAddSelected) {message = translate(MODAL_TEXTS.maxForOneAddTooltip, { max: MAX_TOPICS_FOR_ONE_ADD });}

    if (!selectedTopics) {message = translate(MODAL_TEXTS.shouldSelectOne);}

    return {
        isMaxSelected,
        isMaxForOneAddSelected,
        message: message,
        isValid: !isMaxSelected && !isMaxForOneAddSelected,
    };
};
